import { LocalOptionDetails } from "src/components/NewComponents/Exam/OptionDetails/LocalOptionDetails";
import { LocalOptionsList } from "src/components/NewComponents/Exam/OptionsList/LocalOptions";
import isMobile from "src/helpers/isMobile";
import { useQuestionsListSettings } from "src/reducers/questions";

export function LocalOptions({ question }) {
  const { state, dispatch, aiFilterActive } = useQuestionsListSettings();

  const runDispatch = (action) => {
    return dispatch({
      ...action,
      id: question.id,
    });
  };

  const forceOpenAiDiscussion =
    !isMobile() && !!aiFilterActive && !!question.details?.hasAiDiscussion;

  const settings = {
    settings: {
      discussion:
        forceOpenAiDiscussion || state.settings.discussion === question.id,
      article: state.settings.article === question.id,
      notes: state.settings.notes === question.id,
      comments: state.settings.comments === question.id,
      remark: state.settings.remark === question.id,
      reportError: state.settings.reportError === question.id,
      statistics: !!state.settings.statistics,
      questionLevel: !!state.settings.questionLevel,
    },
  };

  return (
    <>
      <LocalOptionsList
        question={question}
        details={question.details}
        state={settings}
        dispatch={runDispatch}
      />
      <LocalOptionDetails
        question={question}
        state={settings}
        dispatch={runDispatch}
        details={question.details}
      />
    </>
  );
}
